import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import store from "./reduxToolkit/store";
import { Provider } from "react-redux";
import "./index.css";
import RouteErrorBoundary from "./components/errors/PageErrorBoundary";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <RouteErrorBoundary>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
        </RouteErrorBoundary>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
